import { useI18n } from 'vue-i18n'
import i18n from '@/plugins/i18n'

/**
 * Custom i18n composable that handles empty string fallbacks
 * When a translation key returns an empty string, it falls back to English
 */
export function useI18nFallback() {
  const { t, locale } = useI18n()

  const tWithFallback = (key: string, values?: Record<string, unknown>) => {
    const currentTranslation = t(key, values || {})

    // If the current translation is empty and we're not already on English, try English
    if ((currentTranslation === '' || !currentTranslation) && locale.value !== 'en') {
      // Temporarily switch to English locale to get the translation
      const originalLocale = i18n.global.locale.value

      i18n.global.locale.value = 'en'

      const englishTranslation = i18n.global.t(key, values || {})

      i18n.global.locale.value = originalLocale

      return englishTranslation || currentTranslation
    }

    return currentTranslation
  }

  return {
    t: tWithFallback,
    locale,
  }
}
